// extracted by mini-css-extract-plugin
module.exports = {"wrap":"primary-cta-button_wrap__WWXAR","button":"primary-cta-button_button__N8_AB"};